import React from "react";

const SubscriptionsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 2.80008V17.1805C24 17.8186 23.7789 18.3587 23.3368 18.8008C22.8947 19.2429 22.3546 19.464 21.7165 19.464H2.28347C1.64537 19.464 1.10526 19.2429 0.663158 18.8008C0.221053 18.3587 0 17.8186 0 17.1805V2.80008C0 2.16197 0.221053 1.62186 0.663158 1.17976C1.10526 0.737654 1.64537 0.516602 2.28347 0.516602H21.7165C22.3546 0.516602 22.8947 0.737654 23.3368 1.17976C23.7789 1.62186 24 2.16197 24 2.80008ZM1.89474 5.44797H22.1053V2.80008C22.1053 2.70281 22.0647 2.61376 21.9837 2.53292C21.9028 2.45186 21.8138 2.41134 21.7165 2.41134H2.28347C2.18621 2.41134 2.09716 2.45186 2.01632 2.53292C1.93526 2.61376 1.89474 2.70281 1.89474 2.80008V5.44797ZM1.89474 9.47997V17.1805C1.89474 17.2778 1.93526 17.3668 2.01632 17.4477C2.09716 17.5287 2.18621 17.5692 2.28347 17.5692H21.7165C21.8138 17.5692 21.9028 17.5287 21.9837 17.4477C22.0647 17.3668 22.1053 17.2778 22.1053 17.1805V9.47997H1.89474Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export default SubscriptionsIcon;
